import {BehaviorSubject} from 'rxjs';
import {closedModal, openedModal} from './createModal';
import {once} from 'ramda';

function createModalStorage() {
    let modals = new BehaviorSubject(0);

    const opened$ = openedModal.asObservable();
    const closed$ = closedModal.asObservable();

    opened$.subscribe(() => modals.next(modals.value + 1));
    closed$.subscribe(() => modals.next(modals.value - 1));

    return modals.asObservable();
}

export default once(createModalStorage);
